import { ContactFaq } from './ContactFaq';
import { ResultsFaq } from './ResultsFaq';
import { ServicesFaq } from './ServicesFaq';
import { CoverageFaq } from './CoverageFaq';
import { PractitionerFaq } from './PractitionerFaq';
import { ReturnAffectifFaq } from './ReturnAffectifFaq';
import { Accordion } from '../ui/accordion';


export const FaqSection = () => (
<section id="faq" data-testid="faq-section" className="faq-section py-12 md:py-16 bg-gradient-to-b from-black to-gray-950">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-6xl font-bold mb-6 text-red-600">
              Questions Fréquentes
            </h2>
            <p className="text-xl text-gray-300">
              Tout ce que vous devez savoir sur le sorcier vaudou Maître Diamma
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <Accordion type="single" collapsible className="space-y-4">
              <ReturnAffectifFaq />

              <PractitionerFaq />

              <CoverageFaq />

              <ServicesFaq />

              <ResultsFaq />

              <ContactFaq />
            </Accordion>
          </div>
        </div>
      </section>
);
